module.exports = __webpack_public_path__ + "img/logo-w-p.87b45d94e2a402f8e5760a98feb0360f.svg";